import { render } from "./ChatBotComponent.vue?vue&type=template&id=a073f23a&scoped=true"
import script from "./ChatBotComponent.vue?vue&type=script&lang=js"
export * from "./ChatBotComponent.vue?vue&type=script&lang=js"

import "./ChatBotComponent.vue?vue&type=style&index=0&id=a073f23a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a073f23a"]])

export default __exports__